import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km4};
    padding-right: ${theme.spacing.km4};
    max-height: 262px;
    overflow-x: hidden;
    overflow-y: auto;

    .grid-container.sc-fuel-grid-container-h {
      padding: ${theme.spacing.km2} ${theme.spacing.km0};
      margin: ${theme.spacing.km0};
      gap: ${theme.spacing.km0} ${theme.spacing.km2};
      align-items: center;
    }

    .grid-container.sc-fuel-grid-container-h:not(:last-child) {
      padding-bottom: ${theme.spacing.km5};
      margin-bottom: ${theme.spacing.km5}!important;
      border-bottom: ${theme.border.width.thinner} ${theme.border.style.solid}
        ${theme.color.border.neutral.default};
    }
  `}
`;
